import { ISingleIdParams } from '../types/actionParams';
import { IPublishedConnectionActions } from '../types/IPublishedConnectionActions';
import { Request } from './Request';

export class GetPublishedConnectionActionsRequest extends Request<ISingleIdParams, IPublishedConnectionActions> {
  constructor(id: string) {
    super('getPublishedConnectionActions', { id: id });
  }
}
